<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div
        class="btn btn-hover bg-secondary-color"
        style="padding: 10px 50px; color: #fff"
      >
        Faqs
      </div>
      <div class="big-caption text-default-color">
        What would you like to find out?
      </div>
      <form action="">
        <input
          type="text"
          placeholder="E.g. How can I become a HuiosPay Merchant"
        />
      </form>
    </div>
  </div>

  <div class="container d-flexbox col">
    <div
      class="flat-card d-flexbox row"
      *ngFor="let item of aboutFaq"
      data-aos="zoom-in"
      data-aos-duration="2000"
    >
      <div class="icon"><img [src]="item.icon" alt="" /></div>
      <div
        class="d-flexbox col justify-content-left align-items-left justify-self-left align-self-top"
        style="padding-bottom: 20px"
      >
        <span
          class="caption-primary-color small-caption text-align-left"
          style="padding: 5px"
          >{{ item.title }}</span
        >
        <span class="text-secondary-color">{{ item.desc }}</span>
      </div>
    </div>
  </div>
  <div class="container d-flexbox col" style="margin-top: -20px">
    <div
      class="flat-card d-flexbox row"
      data-aos="zoom-in"
      data-aos-duration="2000"
    >
      <div class="icon"><img src="item.icon" alt="" /></div>
      <div
        class="d-flexbox col justify-content-left align-items-left justify-self-left align-self-top"
        style="padding-bottom: 20px"
      >
        <span
          class="caption-primary-color small-caption text-align-left"
          style="padding: 5px"
          >Frequently asked questions
        </span>
        <div *ngFor="let item of faq">
          <button class="accordion text-secondary-color" (click)="status(item.id)">
            {{ item.question }} <span style="rotate: 22px">&#x3e;</span>
          </button>
          <div class="panel">
            <p >
              <!-- *ngIf="showMsg" -->
              {{item.answer}}
            </p>
          </div>
        </div>

        <!-- <button class="accordion text-secondary-color" >Section 2</button>
        <div class="panel">
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat.</p>
        </div> -->

        <!-- <button class="accordion text-secondary-color" >Section 3</button>
        <div class="panel">
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat.</p>
        </div> -->
      </div>
    </div>
  </div>

  <div class="container activity d-flexbox col">
    <h1>Recent Activity</h1>
    <div class="d-flexbox row flex-wrap">
      <div
        class="d-flexbox col justify-content-left align-items-left flex-1 activity-card"
        *ngFor="let item of recentActivity"
        data-aos="zoom-in"
        data-aos-duration="2000"
      >
        <span class="btn barge-bg-color justify-self-left align-self-left">
          {{ item.badge }}
        </span>
        <span class="caption-primary-color"> {{ item.title }} </span>
        <span class="text-primary-color" style="font-size: small">
          {{ item.faq }}
        </span>
        <span class="text-tertiary-color" style="font-size: smaller">
          {{ item.createdAt }}
        </span>
      </div>
    </div>
  </div>

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

  <app-back-to-top
    [acceleration]="2"
    [animate]="true"
    [scrollDistance]="50"
    [speed]="50"
  >
  </app-back-to-top>
</div>
